import React, { useState } from 'react';
import { Spinner, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faLock, faEnvelope, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import request from '../../../../../request';
import Notify from '../../../../compartidos/Notify';

/**
 * DeviceActivator - Security layer to authorize Kiosks and Displays
 */
const DeviceActivator = ({ onActivated, sucursalId }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const handleActivate = (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            ...formData,
            sucursalId: sucursalId
        };

        request.Post(process.env.REACT_APP_API_URL + 'turnero/activateDevice', payload, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Dispositivo activado correctamente' });
                localStorage.setItem('dm_installation_token', r.token);
                if (onActivated) onActivated(r.token);
            } else {
                Notify({ type: 'fail', text: r.msg || 'Error de activación' });
            }
            setLoading(false);
        });
    };

    return (
        <div className="device-activator-overlay d-flex align-items-center justify-content-center">
            <Container>
                <Row className="justify-content-center">
                    <Col md={6} lg={5}>
                        <div className="turnero-card p-5 animate-in" style={{ border: '2px solid var(--turnero-primary)', boxShadow: '0 0 40px rgba(99, 102, 241, 0.2)' }}>
                            <div className="text-center mb-4">
                                <div className="activation-icon-wrapper mb-3">
                                    <FontAwesomeIcon icon={faShieldAlt} size="4x" className="text-primary" />
                                </div>
                                <h2 className="turnero-title mb-2">Activación Requerida</h2>
                                <p className="text-muted">Este dispositivo no ha sido autorizado para operar en la sucursal <strong>#{sucursalId}</strong>.</p>
                            </div>

                            <form onSubmit={handleActivate}>
                                <div className="mb-3">
                                    <label className="modal-finish-label">EMAIL ADMINISTRADOR</label>
                                    <div className="position-relative">
                                        <FontAwesomeIcon icon={faEnvelope} className="position-absolute" style={{ left: '1.2rem', top: '50%', transform: 'translateY(-50%)', opacity: 0.5 }} />
                                        <input
                                            type="email"
                                            className="modal-finish-input w-100"
                                            style={{ paddingLeft: '3rem' }}
                                            placeholder="admin@empresa.com"
                                            value={formData.email}
                                            onChange={e => setFormData({ ...formData, email: e.target.value })}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="modal-finish-label">CONTRASEÑA</label>
                                    <div className="position-relative">
                                        <FontAwesomeIcon icon={faLock} className="position-absolute" style={{ left: '1.2rem', top: '50%', transform: 'translateY(-50%)', opacity: 0.5 }} />
                                        <input
                                            type="password"
                                            className="modal-finish-input w-100"
                                            style={{ paddingLeft: '3rem' }}
                                            placeholder="••••••••"
                                            value={formData.password}
                                            onChange={e => setFormData({ ...formData, password: e.target.value })}
                                            required
                                        />
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    className="turnero-btn turnero-btn-primary w-100 py-3 justify-content-center"
                                    disabled={loading}
                                    style={{ fontSize: '1.1rem' }}
                                >
                                    {loading ? <Spinner animation="border" size="sm" /> : (
                                        <><FontAwesomeIcon icon={faCheckCircle} className="mr-2" /> ACTIVAR DISPOSITIVO</>
                                    )}
                                </button>
                            </form>

                            <div className="mt-4 p-3 rounded  border border-warning" style={{ opacity: 0.8 }}>
                                <div className="small text-warning d-flex align-items-center">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
                                    <span>Solo el administrador general de la empresa puede realizar esta acción.</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

            <style>{`
                .device-activator-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: radial-gradient(circle at center, #1e293b, #030816);
                    z-index: 9999;
                    backdrop-filter: blur(10px);
                }
                .activation-icon-wrapper {
                    width: 100px;
                    height: 100px;
                    background: rgba(99, 102, 241, 0.1);
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto;
                }
            `}</style>
        </div>
    );
};

export default DeviceActivator;
